import { useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/content`;
const cache = {};

export function useContentWithStatus(resource, fallback) {
  const [data, setData] = useState(cache[resource] || fallback);
  const [loaded, setLoaded] = useState(Boolean(cache[resource]));

  useEffect(() => {
    let active = true;
    axios
      .get(`${API}/${resource}`)
      .then((r) => {
        if (active && Array.isArray(r.data) && r.data.length) {
          cache[resource] = r.data;
          setData(r.data);
        }
      })
      .catch(() => {})
      .finally(() => {
        if (active) setLoaded(true);
      });
    return () => {
      active = false;
    };
  }, [resource]);

  return { data, loaded };
}

export default function useContent(resource, fallback) {
  return useContentWithStatus(resource, fallback).data;
}
